<template>
  <v-app>
    <Header />
    <MainNavigationDrawer ref="mainNavigationDrawer" />
    <v-main>
      <router-view id="main-view" />
    </v-main>
  </v-app>
</template>

<script>
import Header from "./home/Header.vue";
import MainNavigationDrawer from "./home/MainNavigationDrawer.vue";

export default {
  name: "MainView",
  components: {
    Header,
    MainNavigationDrawer,
  },
};
</script>

<style scoped>
#main-view {
  width: 100%;
  height: 100%;
}
</style>
